import Route from '@ember/routing/route';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';
import { NotificationCreateType } from 'webapp/enums/notifications';

export default class SettingsNotificationsTypeIndexRoute extends Route {
	@service('model-manager/notifications')
	declare mmNotificationsService: Service.ModelManager.Notifications;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('billing') declare billingService: Service.Billing;

	override afterModel(params: { type: string }) {
		const limitation = this.mmNotificationsService.checkLimitationForCreateType(
			params.type as NotificationCreateType,
		);
		if (limitation) {
			this.navigationService.replaceRoute('settings.notifications').then(() => {
				this.billingService.handleLimitations(limitation);
			});
		} else {
			this.navigationService.transitionToRoute('settings.notifications').then(() => {
				this.mmNotificationsService.createAndEdit(params.type as NotificationCreateType);
			});
		}
	}
}
